import { render, staticRenderFns } from "./promotionEdit.vue?vue&type=template&id=282673dd&"
import script from "./promotionEdit.vue?vue&type=script&lang=js&"
export * from "./promotionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports